import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Film, Calendar, MapPin } from "lucide-react";

const PLACEHOLDER_FESTIVALS = [
  { id: "p1", name: "Kanab Film Festival", location: "Kanab, UT", deadline: "Rolling", category: "Feature · Short · Doc" },
  { id: "p2", name: "Red Rock Film Festival", location: "St. George, UT", deadline: "Sep 15", category: "All formats" },
  { id: "p3", name: "Zion Film Festival", location: "Springdale, UT", deadline: "Aug 30", category: "Short · Doc" },
  { id: "p4", name: "Moab Music & Film", location: "Moab, UT", deadline: "Oct 10", category: "Music video · Short" },
];

export default function Festivals() {
  const [festivals, setFestivals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const data = await api.festivals();
        if (alive) setFestivals(Array.isArray(data) && data.length ? data : PLACEHOLDER_FESTIVALS);
      } catch { if (alive) setFestivals(PLACEHOLDER_FESTIVALS); }
      finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <div>
      <div className="relative rounded-2xl overflow-hidden h-56 mb-10 border border-white/10">
        <img src="https://images.pexels.com/photos/414136/pexels-photo-414136.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1600" className="w-full h-full object-cover" alt="" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/40 to-transparent" />
        <div className="absolute inset-0 flex flex-col justify-end p-8">
          <div className="text-xs uppercase tracking-[0.3em] ff-accent-text mb-2">Festival Hub</div>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tighter leading-none font-medium">Every deadline. Every canyon.</h1>
        </div>
      </div>

      {loading ? (
        <div className="text-sm text-neutral-500">Loading festivals…</div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 ff-stagger" data-testid="festivals-grid">
          {festivals.map((f, i) => (
            <div key={f.id || i} className="ff-card p-6" data-testid={`festival-card-${i}`}>
              <div className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center mb-4">
                <Film className="w-4 h-4 ff-accent-text" />
              </div>
              <div className="font-display text-xl tracking-tight leading-tight">{f.name || f.title}</div>
              <div className="text-xs uppercase tracking-widest text-neutral-500 mt-2">{f.category || "Festival"}</div>
              <div className="mt-4 text-sm text-neutral-300 flex items-center gap-3">
                {f.location && <span className="inline-flex items-center gap-1"><MapPin className="w-3.5 h-3.5 ff-accent-text" /> {f.location}</span>}
              </div>
              <div className="mt-2 text-sm text-neutral-300 flex items-center gap-1">
                <Calendar className="w-3.5 h-3.5 ff-accent-text" />
                Deadline: {f.deadline || "TBD"}
              </div>
              {f.website && <a href={f.website} target="_blank" rel="noreferrer" className="mt-4 inline-block text-xs ff-accent-text hover:underline">Visit website →</a>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
